module.exports = __webpack_public_path__ + "img/coupon_bg.639100a4.png";